import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { getAccessToken } from '@ecp/common/src/utils/utils';

import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import UserInfoProvider from '@mo-components/common/provider/UserInfoProvider';
import GuestRoutes from '@ecp/mo/src/routes/GuestRoutes';

const ProtectedRoutes = () => {
  const { isNoMemberUseYn } = useSiteInfo();
  const { pathname, search } = useLocation();

  const notLoggedInRoutes = () => {
    switch (isNoMemberUseYn) {
      case true:
        return <GuestRoutes />;
      case false:
        return <Navigate to="/login" state={{ prev: pathname + search, current: '/login' }} />;
      default:
        return <></>;
    }
  };

  return getAccessToken() ? (
    <UserInfoProvider>
      <Outlet />
    </UserInfoProvider>
  ) : (
    notLoggedInRoutes()
  );
};

export default ProtectedRoutes;
